export default __webpack_public_path__ + "media/images/lp/payment-sp-d2c5450d30142fa991d3a4e52708e21b.jpg";